import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import {
  getCurrentDateTimeYYMMDDHHMMSS,
  dateFormat,
  formatDecimal,
  isAdmin,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import PaymentTable from "../../Sales/PaymentTable"
import {
  getSalesInvoice,
  emailSalesInvoice,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceApi"
import { proxyFile } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import Footer from "../../../Components/Footer/Footer"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import SalesModal from "../Component/SalesModal"
import "../SalesModules.css"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import Modal from "antd/es/modal/Modal"

export default function SalesInvoicePrint() {
  const { id } = useParams() // id
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [salesInvoice, setSalesInvoice] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)
  const [prepBySignature, setPrepBySignature] = useState()
  const [fileList, setFileList] = useState([])
  const [previewFile, setPreviewFile] = useState("")
  const [preview, setPreview] = useState(false)

  async function fetchSalesInvoice() {
    setSalesInvoice({})
    setPaymentInfo([])
    setItems([])

    const response = await getSalesInvoice({ id: id })

    if (response.error) {
      TokenExpiry(response)
    } else {
      var details = response.data.data[0]
      setFileList(response.data.data[0].sales_invoice_attachments)
      setSalesInvoice(details)
      setItems(details.sales_invoice_items)

      // Convert signature to base64 after data is loaded
      convertFromHtmlToImage(details)

      // var payment = details?.sales_invoice_payments?.map((data) => {
      //   if (data.paid_amount !== "0.00") {
      //     var info = data
      //     info.paid_amount = numberFormat(data.amount)
      //     info.payment_date = dateFormat(data.payment_date)
      //     // info.deposit_amount = response.data.deposit_amounts[info.payment_no] ? numberFormat(response.data.deposit_amounts[info.payment_no]) : ""
      //     if (data.payment_type === "check") {
      //       info.payment_type = data.payment_type + "-" + data.cheque_number
      //     }
      //     info.bank_to_name = data.bank_to_name ? data.bank_to_name : "N/A"
      //     setPaymentInfo((prev) => [...prev, info])
      //     return info
      //   }
      // })
    }
  }

  const handleSendEmail = async (ref) => {
    if (ref) {
      const element = document.getElementById(ref)
      setIsClicked(true)

      html2canvas(element).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7) // Adjust the quality here (0.7 is just an example)
        const pdf = new jsPDF()
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 5
        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        )

        // Convert the pdf file from Blob to File obj (needed for upload API)
        var blobPdf = pdf.output("blob")

        const dateToday = getCurrentDateTimeYYMMDDHHMMSS()
        const formPdf = new File([blobPdf], `Sales_Invoice_${dateToday}.pdf`, {
          type: blobPdf.type,
        })

        console.log(formPdf)

        // if (printPO.supplier_email || printPO.vendor_email) {
        const response = await emailSalesInvoice(id, formPdf)

        if (response.response) {
          toast.success(response.response.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/wholesaleinvoice", {
              params: {
                state: "sent",
              },
            })
          }, 1000)
        } else {
          setIsClicked(false)
          toast.error("Email not sent", {
            style: toastStyle(),
          })
          setTimeout(() => {
            setIsClicked(false)
            handleCloseSendModal()
          }, 1000)
        }
        // }
      })
    }
  }
  async function convertFromHtmlToImage(data) {
    const preparedBySignatureLink = data.added_by_name_signature
    try {
      if (preparedBySignatureLink) {
        const prepByBase64Data = await imageUrlToBase64(preparedBySignatureLink)
        setPrepBySignature(prepByBase64Data)
      }
    } catch (error) {
      console.error("Error converting signature:", error)
    }
  }

  async function imageUrlToBase64(url) {
    try {
      const res = await proxyFile(url)
      if (!res || res.error) return null
      if (!res.blob) return null

      return await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(res.blob)
      })
    } catch (error) {
      console.error("Error converting image URL to base64:", error)
      return null
    }
  }

  async function handlePrint() {
    toast.loading("Printing sales invoice...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }
  async function handlePrintWarehouse() {
    toast.loading("Printing sales invoice for warehouse...", {
      style: toastStyle(),
    })
    setTimeout(() => {
      toast.dismiss()
      PrintWarehouse()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th></th>
            <th>Item Code</th>
            <th>Product</th>
            <th>Ordered Quantity</th>
            <th>Quantity Sent</th>
            <th>Balance</th>
            <th>U o M</th>
            <th>Size</th>
            <th>Price/Unit</th>
            <th>Discount</th>
            <th>Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items &&
            items?.map((item, index) => {
              const balance = item.ordered_qty - item.qty
              return (
                <tr key={index} className="req-table-w-border-bottom">
                  <td className="req-table-w-border-sides print-label">
                    {index + 1}
                  </td>
                  <td className="req-table-w-border-sides">{item.item_code}</td>
                  <td className="req-table-w-border-sides">
                    {item.description
                      ? item.description + " - " + item.item_name
                      : item.item_name}
                  </td>
                  <td className="req-table-w-border-sides">
                    {Math.floor(item.ordered_qty)}
                  </td>
                  <td className="req-table-w-border-sides">
                    {Math.floor(item.qty)}
                  </td>
                  <td className="req-table-w-border-sides">{balance}</td>
                  <td className="text-lowercase req-table-w-border-sides">
                    {item.unit}
                  </td>
                  <td className="req-table-w-border-sides">{item.item_size}</td>
                  <td className="req-table-w-border-sides">{item.price}</td>
                  <td>
                    {`${formatDecimal(item.discount_amount)} (${formatDecimal(
                      item.discount_percentage
                    )}%)`}
                  </td>
                  <td className="req-table-w-border-sides">
                    {numberFormat(item.amount)}
                  </td>
                  <td className="req-table-w-border-sides">
                    {item.item_remarks}
                  </td>
                </tr>
              )
            })}
          {/* {items.map((item) => {
                        return (
                            <tr className="req-table-w-border-bottom">
                                <td className="req-table-w-border-sides">{item.description ? 
                                                                            item.item_name ? item.description + " - " + item.item_name :
                                                                            item.description : item.item_name
                                                                        }</td>
                                <td className="text-end req-table-w-border-sides">{numberFormat(item.qty)}</td>
                                <td className=" req-table-w-border-sides">{item.unit}</td>
                                <td className="text-end req-table-w-border-sides">{numberFormat(item.price)}</td>
                                <td className="text-end req-table-w-border-sides">{numberFormat(item.discount_amount)}</td>
                                <td className="text-end req-table-w-border-sides">{numberFormat(item.amount)}</td>
                                <td className="text-end req-table-w-border-sides">{item.item_remarks}</td>
                            </tr>
                        );
                    })} */}
          {/* <tr>
                        <td colSpan={7}>
                            <div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Subtotal</td>
                        <td className="right">
                            {salesInvoice.subtotal
                                ? numberFormat(salesInvoice.subtotal)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Service Fee</td>
                        <td className="right">
                            {salesInvoice.service_fee
                                ? numberFormat(salesInvoice.service_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">Delivery Fee</td>
                        <td className="right">
                            {salesInvoice.delivery_fee
                                ? numberFormat(salesInvoice.delivery_fee)
                                : "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5}></td>
                        <td className="left">GRAND TOTAL</td>
                        <td className="right">
                            {salesInvoice.grand_total
                                ? numberFormat(salesInvoice.grand_total)
                                : "0.00"}
                        </td>
                    </tr> */}
        </tbody>
      </Table>
    )
  }

  function renderWarehouseTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Transfer Qty</th>
            <th>Item</th>
            <th>Unit</th>
            <th className="text-end">Quantity</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides"></td>
                <td className="req-table-w-border-sides">{item.item_name}</td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className="req-table-w-border-sides"></td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }
  function PrintWarehouse() {
    let printContents = document.getElementById(
      "printabledivwarehouse"
    ).innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  useEffect(() => {
    fetchSalesInvoice()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"FRANCHISE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <br />
        <br />
        <div className="print-container px-3 py-2" id="printablediv">
          {/* <div
                        className={
                            salesInvoice.fs_status === "invoiced"
                                ? "text-end print-header d-flex flex-column"
                                : "text-start print-header d-flex flex-column"
                        }
                    >
                        <span>SALES INVOICE ID# {id}</span>
                        <span className="text-uppercase">
                            {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
                        </span>
                    </div> */}
          <div className="print-header-invoice-elm mb-5">
            <div className="d-flex justify-content-center py-1">
              <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
            </div>
            <div className="print-top">
              <h5 className="print-shop-header-elm d-flex justify-content-center print-data">
                497 D Molave Extension, Lahug, Cebu City
              </h5>
              {/* <h5 className="print-shop-header-elm d-flex justify-content-center">San Roque, Cebu City</h5> */}
            </div>
          </div>
          <h2 className="delivery-title-elm my-4 ms-2">DELIVERY NOTE</h2>
          <div className="d-flex flex-column gap-3 flex-sm-row align-items-start justify-content-start mx-2">
            <div className="invoice-header2-left w-full">
              <h5 className="print-pi-tin-elm print-data bold">
                To: {salesInvoice.customer_name}
              </h5>
              <h5 className="print-pi-tin-elm print-data">
                TIN: {salesInvoice.customer_tin}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Address: {salesInvoice.address}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Terms: {salesInvoice.terms} days
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Released from: {salesInvoice.release_from_name}
              </h5>
              <h5 className="print-pi-address-elm print-data">
                Released by: {salesInvoice.release_by_name}
              </h5>
            </div>
            <div className="d-flex gap-3 w-full justify-content-start justify-content-sm-end">
              <div className="">
                <h5 className="print-shop-header-elm print-data text-end">
                  Delivery No.:{" "}
                </h5>
                <h5 className="print-shop-header-elm print-data text-end">
                  Date:{" "}
                </h5>
                {salesInvoice.invoice_no && (
                  <h5 className="print-shop-header-elm print-data text-end">
                    Invoice No.:{" "}
                  </h5>
                )}
                <h5 className="print-shop-header-elm print-data text-end">
                  SO Ref. No.:{" "}
                </h5>
                {salesInvoice.customer_po_no !== "undefined" &&
                salesInvoice.customer_po_no !== null ? (
                  <h5 className="print-shop-header-elm print-data text-end">
                    Cust. PO No.:
                  </h5>
                ) : (
                  <></>
                )}
                <h5 className="print-shop-header-elm print-data text-end">
                  Due Date:{" "}
                </h5>
                <h5 className="print-shop-header-elm print-data text-end">
                  Ship Via:{" "}
                </h5>
                <h5 className="print-shop-header-elm print-data text-end">
                  Delivery Date:{" "}
                </h5>
              </div>
              <div className="">
                <h5 className="print-shop-header-elm print-data">
                  {salesInvoice.id}
                </h5>
                <h5 className="print-shop-header-elm print-data">
                  {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
                </h5>
                {salesInvoice.invoice_no && (
                  <h5 className="print-shop-header-elm print-data">
                    {salesInvoice.invoice_no}
                  </h5>
                )}
                <h5 className="print-shop-header-elm print-data">
                  {salesInvoice.sales_order_id}
                </h5>
                {salesInvoice.customer_po_no !== "undefined" &&
                salesInvoice.customer_po_no !== null ? (
                  <h5 className="print-shop-header-elm print-data">
                    {salesInvoice.customer_po_no}
                  </h5>
                ) : (
                  <></>
                )}
                <h5 className="print-shop-header-elm print-data">
                  {dateFormat(salesInvoice.due_date)}
                </h5>
                <h5 className="print-shop-header-elm print-data">
                  {salesInvoice.ship_via === "pick_up"
                    ? "Pick Up"
                    : salesInvoice.ship_via}
                </h5>
                <h5 className="print-shop-header-elm print-data">
                  {dateFormat(salesInvoice.delivery_date)}
                </h5>
              </div>
            </div>
          </div>
          {/* content */}
          <div className="mt-5 justify-content-start">
            {/* <Row className="d-flex align-items-start ms-5">
                            <Col xs={6} lg={5} md={4}>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Customer:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.customer_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.branch_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        Released From:
                                    </Col>
                                    <Col xs={5} className="print-data">
                                        {salesInvoice.release_from_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        Released By:
                                    </Col>
                                    <Col xs={5} className="print-data">
                                        {salesInvoice.release_by_name}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Invoice Status:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.status}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Invoice No.:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.invoice_no}
                                    </Col>
                                </div>
                            </Col>
                            <Col xs={6} lg={5} md={6}>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Transfer Slip No.:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {salesInvoice.transfer_slip_no}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Order Request Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(salesInvoice.order_request_date)}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={4} className="print-label">
                                        Sales Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(salesInvoice.sales_date)}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        Ship Via:
                                    </Col>
                                    <Col xs={5} className="print-data">
                                        {salesInvoice.ship_via === "pick_up" ? "Pick Up" : salesInvoice.ship_via}
                                    </Col>
                                </div>
                                <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        Delivery Date:
                                    </Col>
                                    <Col xs={5} className="print-data">
                                        {dateFormat(salesInvoice.delivery_date)}
                                    </Col>
                                </div>
                            </Col>
                        </Row> */}
            <div className="d-flex mt-2 justify-content-evenly">
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>

            <div className="mt-2 ml-5">
              <span className="print-footer">
                for additional orders call 0917-511-1171
              </span>
            </div>
            {salesInvoice.remarks && (
              <Row className="mt-2 ml-5">
                <span className="print-pi-address-elm print-data">
                  {" "}
                  Remarks: {salesInvoice.remarks}
                </span>
              </Row>
            )}

            <div className="d-flex flex-row gap-3 justify-content-end mx-3 mt-3">
              <div className="d-flex flex-column">
                <h5 className="text-end print-table-footer-label">Subtotal:</h5>
                <h5 className="text-end print-table-footer-label">discount:</h5>
                <h5 className="text-end print-table-footer-label">
                  discount subtotal:
                </h5>
                <h5 className="text-end print-table-footer-label">vat:</h5>
                <h5 className="text-end print-table-footer-label">
                  vatable sales:
                </h5>
                <h5 className="text-end print-table-footer-label">
                  wht ({formatDecimal(salesInvoice.withholding_percentage)} %):
                </h5>
                <h5 className="text-end print-table-footer-label">
                  grand total:
                </h5>
                <h5 className="text-end print-table-footer-label">
                  delivery service fee:
                </h5>
                <h5 className="text-end bold print-table-footer-label">
                  Total amount due:
                </h5>
              </div>
              <div>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.subtotal
                    ? numberFormat(salesInvoice.subtotal)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.discount
                    ? numberFormat(salesInvoice.discount)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.discounted_subtotal
                    ? numberFormat(salesInvoice.discounted_subtotal)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.vat ? numberFormat(salesInvoice.vat) : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.vatable_sales
                    ? numberFormat(salesInvoice.vatable_sales)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.withholding_tax
                    ? numberFormat(salesInvoice.withholding_tax)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {salesInvoice.grandtotal_without_service_fee
                    ? numberFormat(salesInvoice.grandtotal_without_service_fee)
                    : "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label">
                  {numberFormat(salesInvoice.service_fee) || "0.00"}
                </h5>
                <h5 className="text-end print-table-footer-label bold">
                  {salesInvoice.grand_total
                    ? numberFormat(salesInvoice.grand_total)
                    : "0.00"}
                </h5>
              </div>
            </div>

            {/* <Row className="print-grand-total my-2 mx-0 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label ">
                SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-start"
              >
                {salesInvoice.subtotal
                  ? numberFormat(salesInvoice.subtotal)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 mx-0 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DISCOUNT
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-start"
              >
                {salesInvoice.discount
                  ? numberFormat(salesInvoice.discount)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 mx-0 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DISCOUNT SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-start"
              >
                {salesInvoice.discounted_subtotal
                  ? numberFormat(salesInvoice.discounted_subtotal)
                  : "0.00"}
              </Col>
            </Row>
            {salesInvoice.vat_type && (
              <>
                <Row className="print-grand-total my-2 mx-0 text-end">
                  <Col
                    xs={8}
                    lg={11}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VAT
                  </Col>
                  <Col
                    xs={2}
                    lg={1}
                    md={3}
                    className="print-table-footer-data text-start"
                  >
                    {salesInvoice.vat ? numberFormat(salesInvoice.vat) : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-2 mx-0 text-end">
                  <Col
                    xs={8}
                    lg={11}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VATABLE SALES
                  </Col>
                  <Col
                    xs={2}
                    lg={1}
                    md={3}
                    className="print-table-footer-data text-start"
                  >
                    {salesInvoice.vatable_sales
                      ? numberFormat(salesInvoice.vatable_sales)
                      : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-2 mx-0 text-end">
                  <Col
                    xs={8}
                    lg={11}
                    md={6}
                    className="print-table-footer-label"
                  >
                    WHT({numberFormatInt(salesInvoice.withholding_percentage)}{" "}
                    %)
                  </Col>
                  <Col
                    xs={2}
                    lg={1}
                    md={3}
                    className="print-table-footer-data text-start"
                  >
                    {salesInvoice.withholding_tax
                      ? numberFormat(salesInvoice.withholding_tax)
                      : "0.00"}
                  </Col>
                </Row>
              </>
            )}
            <Row className="print-grand-total my-2 mx-0 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                GRAND TOTAL
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-start"
              >
                {salesInvoice.grandtotal_without_service_fee
                  ? numberFormat(salesInvoice.grandtotal_without_service_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 mx-0 text-end">
              <Col xs={8} lg={11} md={6} className="print-table-footer-label">
                DELIVERY/SERVICE FEE
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="print-table-footer-data text-start"
              >
                {salesInvoice.service_fee || "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 mx-0 text-end">
              <Col
                xs={8}
                lg={11}
                md={6}
                className="bold print-table-footer-label"
              >
                TOTAL AMOUNT DUE
              </Col>
              <Col
                xs={2}
                lg={1}
                md={3}
                className="bold print-table-footer-data text-start"
              >
                {salesInvoice.grand_total
                  ? numberFormat(salesInvoice.grand_total)
                  : "0.00"}
              </Col>
            </Row> */}
            <Row className="print-grand-total mt-3 mx-0 text-end mb-5">
              <Col className="bold print-table-footer-label">
                <span className="cheque-pay-to">
                  Cheque pay to ELHMHURST ENTERPRISES COMPANY
                </span>
              </Col>
            </Row>

            <Row className="mt-5 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex flex-column align-items-center">
                <img
                  // src={salesInvoice.added_by_name_signature}
                  src={prepBySignature}
                  className="print-logo mb-2"
                  alt=""
                />
                <p className="print-data text-center">{salesInvoice.added_by_name}</p>
                <div className="margin-underline" style={{width: '200px'}}></div>
                <p className="print-data mt-2 text-center">Prepared by</p>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex flex-column align-items-center" style={{marginTop: '150px'}}>
                <div className="margin-underline" style={{width: '200px'}}></div>
                <p className="print-data mt-2 text-center">Noted by (Receiver)</p>
              </Col>
            </Row>
          </div>
        </div>

        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          <Row className="">
            {fileList &&
              fileList.map((attachment) => (
                <Col
                  xs={1}
                  onClick={() => {
                    setPreviewFile(attachment.file_url)
                    setPreview(true)
                  }}
                  className="cursor-pointer preview-container"
                >
                  <img
                    src={attachment.file_url}
                    className="img-preview"
                    alt=""
                  />
                </Col>
              ))}
            {!fileList ||
              (fileList.length === 0 && (
                <Col xs={1}>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                    <img
                      src={noDataImg}
                      alt="no data found"
                      className="img-preview"
                    />
                  </div>
                </Col>
              ))}
          </Row>
        </div>

        <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
          <div className="justify-content-center">
            <PaymentTable
              tableHeaders={[
                "PMT DATE",
                "INV NO.",
                "TYPE",
                "PAID AMT",
                // "DEPOSIT AMT",
                // "DEPOSIT DATE",
                "COMMISSION",
                "DEPOSITED TO",
                "REMARKS",
              ]}
              headerSelector={[
                "payment_date",
                "invoice_no",
                "payment_mode",
                "paid_amount",
                // "deposit_amount",
                // "deposit_date",
                "commission",
                "bank_to_name",
                "particulars",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/wholesaleinvoice")}
          >
            Close
          </button>
          {salesInvoice.payment_status === "open_bill" && isAdmin() ? (
            <button
              className="button-tertiary me-3"
              onClick={() => navigate("/wholesaleinvoice/edit/" + id)}
            >
              Edit
            </button>
          ) : (
            ""
          )}
          {salesInvoice.fs_status === "processing" && (
            <button
              className="button-secondary me-3"
              onClick={handlePrintWarehouse}
            >
              Print Warehouse
            </button>
          )}
          <button
            className="button-tertiary me-3"
            onClick={handleShowSendModal}
          >
            Email to Customer
          </button>
          <button className="button-primary" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <Footer />
      <SalesModal
        show={showSendModal}
        hide={handleCloseSendModal}
        message="Are you sure want to send this sales invoice to the customer?"
        handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
    </div>
  )
}
